import { NavLink, Outlet, useLocation } from "react-router-dom";
import { LayoutDashboard, Users, Upload, Settings, ClipboardCheck, ScrollText, BookOpen } from "lucide-react";
import { cn } from "@/lib/utils";

const TABS = [
  { to: "/admin", end: true, label: "Dashboard", icon: LayoutDashboard, testid: "admin-tab-dashboard" },
  { to: "/admin/courses", label: "Courses", icon: BookOpen, testid: "admin-tab-courses" },
  { to: "/admin/users", label: "Users & invitations", icon: Users, testid: "admin-tab-users" },
  { to: "/admin/assessments", label: "Assessments", icon: ClipboardCheck, testid: "admin-tab-assessments" },
  { to: "/admin/import", label: "Import CSV", icon: Upload, testid: "admin-tab-import" },
  { to: "/admin/audit", label: "Audit log", icon: ScrollText, testid: "admin-tab-audit" },
  { to: "/admin/settings", label: "Settings", icon: Settings, testid: "admin-tab-settings" },
];

export default function AdminLayout() {
  return (
    <div className="fade-in">
      <h1 className="mb-1 font-heading text-[28px] font-semibold tracking-tight sm:text-[32px]">Administration</h1>
      <p className="mb-5 text-[15px] text-muted-foreground">Manage users, content and platform settings.</p>

      <div className="sticky top-16 z-20 mb-6 -mx-4 border-b border-border bg-background/85 px-4 backdrop-blur sm:mx-0 sm:px-0">
        <div className="flex gap-1 overflow-x-auto">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              data-testid={t.testid}
              className={({ isActive }) =>
                cn("inline-flex items-center gap-2 whitespace-nowrap border-b-2 px-3.5 py-3 text-sm font-medium transition-colors",
                  isActive ? "border-[#33B6E4] text-foreground" : "border-transparent text-muted-foreground hover:text-foreground")
              }
            >
              <t.icon className="h-4 w-4" /> {t.label}
            </NavLink>
          ))}
        </div>
      </div>

      <Outlet />
    </div>
  );
}
